document.addEventListener("alpine:init", () => {
    Alpine.data("contentSwitcher", () => ({
      currentIndex: 0,
  
      init() {
        // Initialize the first item as selected
        this.currentIndex = 0;
      },
  
      selectItem(index, event) {
        this.currentIndex = index;
      
        // Only scroll on tablet and mobile (width < 1024px)
        if (window.innerWidth < 1024) {
          this.$nextTick(() => {
            const element = event.target;
            const offset = 250;
            const elementTop = element.getBoundingClientRect().top;
            const finalScroll = window.scrollY + elementTop - offset;
        
            window.scrollTo({
              top: finalScroll,
              behavior: "smooth",
            });
          });
        }
      }
    }));
  });
  